import { getAuth, signOut } from 'firebase/auth';
import React, {useContext} from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '../../App';
import app from '../../firebase.init';

const Nav = () => {
    let {exist, setExist, setUser} = useContext(UserContext);
    let auth = getAuth(app)

    let signOutClicked = ()=>{
        signOut(auth)
            .then()
            .catch((err)=> console.error(err))

        setExist(false)
        setUser({})
    }

    return (
        <div className="navbar bg-base-100 shadow-xl">
        <div className="navbar-start">
            <Link className="btn btn-ghost normal-case text-xl" to='/'>Practice</Link>
        </div>
        {
            !exist ? 
            <div className="navbar-end">
                    <Link to='/login' className="btn">Log In</Link>
            </div> : 
            <div className="navbar-end" onClick={signOutClicked}>
                <Link to='/login' className="btn">Sign Out</Link>
             </div>
        }
        </div>
    );
};

export default Nav;